import * as React from "react";
import { Loader } from "@progress/kendo-react-indicators";

export function Loading(props: any) {
    return (<div className="k-loading-mask loading-dialog" >
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
    </div>)
}